export var radioGroupStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return {
      display: 'flex',
      flexDirection: p.vertical ? 'column' : 'row'
    };
  }
};